/*
 * What a person typed, as the address Orbit reads.
 *
 * People give the link they happen to be standing on, which is often an ad
 * landing page carrying a tracking query longer than the card it is printed
 * on. Two things follow from that. The read wants the company's site, not one
 * campaign page, because the map and every pass after it start from the root.
 * And the screen wants a name, not a query string.
 */

export const siteRoot = (raw: string): string => {
  const typed = (raw || '').trim();
  if (!typed) return '';
  let full = typed;
  if (!/^https?:\/\//i.test(full)) full = `https://${full}`;
  try {
    const url = new URL(full);
    return `${url.protocol}//${url.host}`;
  } catch {
    return typed;
  }
};

export const hostOf = (raw: string): string => {
  const root = siteRoot(raw);
  if (!root) return '';
  return root.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
};
